<!-- <span style="white-space: pre-wrap;">
    {{section.groups.data[0].fields.data|json}}
</span> -->
<div class="doc-icon" [style.backgroundImage]="docIcon">
</div>
<div>
    <a [textContent]="name" class="title" [href]="download"></a>
    <div [textContent]="description" class="description"></div>
</div>
